var _excluded = ["children", "isOpen", "onRequestClose", "shouldCloseOnOverlayClick", "overlayStyleOverrides", "label"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import * as React from "react";
import ReactModal from "react-modal";
import { theme } from "./theme";
import { Title } from "./Text";
import Stack from "./evergreenLib/Stack";
import { ClassNames, GlobalCSS, RAW_cssValue } from "@classdojo/web/nessie/stylingLib";
import UnstyledButton from "../../components/buttons/UnstyledButton";
import translate from "../../utils/translate";
import { CloseIcon } from "../icons";
import { jsx as _jsx } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
import { Fragment as _Fragment } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
import { jsxs as _jsxs } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
export var Modal = function Modal(_ref) {
  var _children = _ref.children,
    isOpen = _ref.isOpen,
    onRequestClose = _ref.onRequestClose,
    shouldCloseOnOverlayClick = _ref.shouldCloseOnOverlayClick,
    _ref$overlayStyleOver = _ref.overlayStyleOverrides,
    overlayStyleOverrides = _ref$overlayStyleOver === void 0 ? {} : _ref$overlayStyleOver,
    label = _ref.label,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return _jsxs(_Fragment, {
    children: [_jsx(GlobalCSS, {
      styles: {
        ".ReactModal__Body--open": {
          overflow: "hidden"
        }
      }
    }), _jsx(Stack, {
      value: theme.stackingOrder.OVERLAY,
      children: function children(zIndex) {
        return _jsx(ClassNames, {
          children: function children(_ref2) {
            var css = _ref2.css,
              cx = _ref2.cx;
            // This overrides styles for the div react-modal uses for the overlay
            var overlayClassName = css({
              backgroundColor: theme.colors.shaleOpacity1,
              position: "fixed",
              // outline: "none",
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              display: "flex",
              flexDirection: "column",
              overflow: "auto"
            }); // This overrides styles for the div react-modal uses to render the content.

            var contentClassName = css({
              // padding - So when the window is raelly small we still see a bit of the overlay on the sides.
              // For some reason the bottom padding does not work ?
              padding: "22px",
              position: "relative",
              // outline: "none",
              display: "flex",
              flexDirection: "column",
              flexShrink: 0,
              flexGrow: 1
            });
            return _jsx(ReactModal, {
              data: otherProps["data-test-name"] && {
                "test-name": otherProps["data-test-name"]
              },
              ariaHideApp: false,
              onRequestClose: onRequestClose,
              overlayClassName: cx(overlayClassName, css({
                zIndex: zIndex
              }), css(overlayStyleOverrides)),
              className: contentClassName,
              isOpen: isOpen,
              shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
              contentLabel: label,
              children: _children
            });
          }
        });
      }
    })]
  });
}; // -----------------------------------
// Modal Content

export var ModalContent = function ModalContent(_ref3) {
  var children = _ref3.children,
    width = _ref3.width,
    maxWidth = _ref3.maxWidth,
    minWidth = _ref3.minWidth,
    _ref3$padding = _ref3.padding,
    padding = _ref3$padding === void 0 ? "l" : _ref3$padding;
  return _jsx("div", {
    sx: {
      // Just setting a min height for easy debugging when working with a modal.
      minHeight: "100px",
      padding: padding,
      border: "1px solid",
      borderColor: "dt_taro30",
      backgroundColor: "dt_white",
      borderRadius: RAW_cssValue("42px"),
      // Since this item is going to live inside a flex container the margin will behave as specified for
      // flex items. Check more here: https://stackoverflow.com/questions/32551291/in-css-flexbox-why-are-there-no-justify-items-and-justify-self-properties/33856609#33856609
      margin: "auto",
      width: width ? width : "100%",
      maxWidth: maxWidth ? maxWidth : "500px",
      minWidth: minWidth ? minWidth : undefined,
      position: "relative"
    },
    children: children
  });
}; // --------------------------------------------
// ModalConfirDialog

export var ModalConfirmDialog = function ModalConfirmDialog(_ref4) {
  var children = _ref4.children;
  return _jsx(ModalContent, {
    maxWidth: "500px",
    children: children
  });
}; // --------------------------------------------
// ModalFooterActions

export var ModalFooterActions = function ModalFooterActions(_ref5) {
  var children = _ref5.children;
  if (React.Children.count(children) > 1) {
    return _jsx("div", {
      sx: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",
        position: "relative",
        flexWrap: "wrap"
      },
      children: React.Children.map(children, function (node) {
        return _jsx("div", {
          sx: {
            position: "relative"
          },
          children: node
        });
      })
    });
  } else {
    return _jsx("div", {
      sx: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        position: "relative"
      },
      children: React.Children.map(children, function (node) {
        return node;
      })
    });
  }
}; // ---------------------------------------------
// Modal Title

export var ModalTitle = function ModalTitle(_ref6) {
  var children = _ref6.children,
    as = _ref6.as;
  return _jsx(Title, {
    as: as,
    textAlign: "center",
    children: children
  });
}; // -------------------------------------------------
// Modal close button

var CLOSE_POSITION = 22;
export var ModalCloseButton = function ModalCloseButton(_ref7) {
  var onClick = _ref7.onClick,
    _ref7$right = _ref7.right,
    right = _ref7$right === void 0 ? false : _ref7$right,
    _ref7$closePosition = _ref7.closePosition,
    closePosition = _ref7$closePosition === void 0 ? CLOSE_POSITION : _ref7$closePosition;
  return _jsx(UnstyledButton, {
    sx: _objectSpread({
      position: "absolute",
      zIndex: 1,
      top: closePosition
    }, right ? {
      right: closePosition,
      "float": "right"
    } : {
      left: closePosition
    }),
    "data-test-name": "nessieModalCloseButton",
    "aria-label": translate({
      str: "dojo.common:actions.close_dialog",
      fallback: "Close dialog"
    }),
    onClick: onClick,
    children: _jsx(CloseIcon, {
      color: "dt_taro60"
    })
  });
};
export var ModalCircledCloseButton = function ModalCircledCloseButton(_ref8) {
  var onClick = _ref8.onClick,
    _ref8$right = _ref8.right,
    right = _ref8$right === void 0 ? false : _ref8$right;
  return _jsx(UnstyledButton, {
    sx: _objectSpread(_objectSpread({
      position: "absolute",
      zIndex: 1
    }, right ? {
      right: CLOSE_POSITION,
      "float": "right"
    } : {
      left: CLOSE_POSITION
    }), {}, {
      top: CLOSE_POSITION,
      padding: "dt_xxs"
    }),
    "data-test-name": "nessieModalCircledCloseButton",
    "aria-label": translate({
      str: "dojo.common:actions.close_dialog",
      fallback: "Close dialog"
    }),
    onClick: onClick,
    children: _jsx(CircledCloseIcon, {})
  });
}; // ----------------------------------------
// CircledCloseIcon

export var CircledCloseIcon = function CircledCloseIcon() {
  return _jsx("div", {
    sx: {
      backgroundColor: "dt_taro10",
      display: "inline-block",
      cursor: "pointer",
      borderRadius: RAW_cssValue("50%"),
      padding: "dt_m",
      lineHeight: 0,
      position: "relative",
      ":hover": {
        backgroundColor: "dt_taro30"
      }
    },
    children: _jsx(CloseIcon, {
      sx: {
        ":hover": {
          color: "dt_taro40"
        }
      }
    })
  });
};